<template>
  <el-container class="page-snap" v-loading="loading">
    <el-header>
      <div class="nav-header">
        <el-row>
          <el-col :span="12">
            <div class="title" v-text="formData.title"></div>
          </el-col>
          <el-col :span="12">
            <div class="layout-right">
              <el-tag>
                快照时间：
                <span v-text="formData.editTime"></span>
              </el-tag>
              <el-button @click.once="onClose">关闭</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-main>
      <el-card class="mt10" v-for="item in formData.items" :key="item.id">
        <div slot="header">
          <b>{{ item.name }}</b>
        </div>
        <div v-html="item.html"></div>
      </el-card>
    </el-main>
  </el-container>
</template>
<script>
import { get } from '@/api/snapshots/snap.js';

export default {
  data() {
    return {
      formData: {},
      loading: false
    };
  },
  methods: {
    onClose() {
      window.close();
    },
    getData() {
      this.loading = true;
      get(this.$route.params.snapEid).then(res => {
        this.formData = res;
        this.loading = false;
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style>
.table-single,
.table-multi {
  background: #e6e6e6;
  width: 100%;
  font-size: 10.5pt;
  border: 0px;
}

.table-single tr,
.table-multi tr {
  background: #fff;
  color: #333;
  height: 55px;
}

.table-multi tr th:first-child {
  width: 60px;
}

.page-snap .title {
  font-size: 16px;
}
</style>
